<script lang="ts" setup>
import { dayjs } from 'element-plus'
const props = defineProps({
  date: String,
  size: {
    type: String
  },
  color: {
    type: String
  }
})
</script>

<template>
  <div class="date" :class="[props.size, props.color]">
    <div class="date__day">{{ dayjs(props.date).format('DD') }}</div>
    <div class="date__right">
      <div class="date__month">{{ dayjs(props.date).format('MMMM') }}</div>
      <div class="date__year">{{ dayjs(props.date).format('YYYY') }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.date {
  display: flex;
  color: $color-gray-2;
  &.small {
    .date {
      &__day {
        font-size: toRem(56);
      }
      &__month,
      &__year {
        font-size: toRem(17);
      }
    }
  }
  &.dark {
    &.date {
      color: $color-black-1;
    }
  }
  &__right {
    padding-left: toRem(10);
  }
  &__day {
    font-family: $font-TextaAlt;
    font-weight: 500;
    font-size: toRem(80);
    letter-spacing: toRem(-1.6);
    line-height: 1;
    @include max-media(480) {
      font-size: toRem(60);
    }
  }
  &__month {
    font-size: toRem(28);
    text-transform: lowercase;
    @include max-media(480) {
      font-size: toRem(22);
    }
  }
  &__year {
    font-size: toRem(16);
    @include max-media(480) {
      font-size: toRem(14);
    }
  }
}
</style>
